import React, { useState, useEffect, useRef } from "react";
import { Button, Tooltip, notification } from "antd";
import { startRecording, stopRecording, cleanupStreams } from "./transcription"; 
import { generateSessionId, displayCustomiseFirstMessageInGTKY } from "./ChatBoxUtilities";
import ChatMessage from "./ChatMessage";
import { useNavigate, useLocation } from "react-router-dom";
import { synthesizeVoice } from "./pollyClient";
import { gettingToKnowYou, gettingToKnowYouResumePrompt, socialMedia, myFriendScripts, getUserName } from "../../constants/constants";
import { getRequest, postRequest } from "../../api";
import { getConversationLimit, getPlanDetails, getScriptStatus } from "../../api/password";
import { isNull } from "lodash";
import microphone from "../../assets/images/microphone.png";
import pauseStartStop from "../../assets/images/pause_play_stop.svg";
import pauseButton from "../../assets/images/pause, play, stop.svg";
import help from "../../assets/images/help.png";
import LimitTrialCard from "../../pages/limittrialpage/LimitTrialCard";
import SubscriptionRestrictionModal from "../subscriptionIOSRestrictionModal/SubscriptionIOSRestrictionModal";
import "./Chatbox.css";

const Chatbox = ({ setAnimationToPlay, isTalkingStarted, setIsTalkingStarted }) => {
  const [transcriptions, setTranscriptions] = useState({ partial: "", final: "" });
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [iosBlockVisible, setIosBlockVisible] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [gettingToKnowResume, setGettingToKnowResume] = useState(null);
  const gettingToKnowResumeConversation = useRef();
  const [pendingBotMessages, setPendingBotMessages] = useState([]);
  const [firstMessage, setFirstMessage] = useState(true);
  const [firstMessageforComponent, setFirstMessageforComponent] = useState(true);
  const [startTime, setStartTime] = useState(null);
  const [rerunEffect, setRerunEffect] = useState(0);
  const [sessionActive, setSessionActive] = useState(false);
  const [showCaptions, setShowCaptions] = useState(true);
  const isScriptCompleted = useRef(false);
  const userName = localStorage.getItem("username");
  const chatboxRef = useRef(null);
  const recordingRef = useRef(false);
  const sessionEndedRef = useRef(false);
  const audioElementRef = useRef(new Audio());
  const botMessageContent = useRef(null);
  const saveConversationTriggered = useRef(false);
  const [responseReceived, setResponseReceived] = useState(false);
  const promptsRef = useRef(null);
  const utterancePromptsPayload = useRef(null);
  const conversationRef = useRef(null);
  const handleAudioEndedRef = useRef();
  const Navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const conversationType = queryParams.get("type");
  const cheerPlaying = useRef(false);
  const promptTypePayload = useRef(null);
  let sadExpression = false;
  const [isPaused, setIsPaused] = useState(false);
  const [audioPosition, setAudioPosition] = useState(0);
  const userId = location.state?.userId || localStorage.getItem("userid");
  const { selectedVoice2 } = location.state || {};
  const togglePopup = () => { setIsPopupVisible(!isPopupVisible) };
  const [user, setUser] = useState({ botName: '', name: '', speechSpeed: '', country: '', city: '', gender: '', hobbies: [] });
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [initialBotMessagePlayed, setInitialBotMessagePlayed] = useState(false);
  const [isBotSpeaking, setIsBotSpeaking] = useState(false);
  const [isInterrupting, setIsInterrupting] = useState(false);
  const [redFlagWords, setRedFlagWords] = useState([]);

  const fetchRedFlagWords = async () => {
    try {
      const response = await getRequest('/conversation/redflag_name');
      if (response) {
        setRedFlagWords(response.redFlagWords || []);
      }
    } catch (err) {
      console.error("Error fetching red flag words:", err);
    }
  };

  useEffect(() => {
    fetchRedFlagWords();
  }, []);
  
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getRequest('/user');
        const avatar = response.chooseAvatar;
        const botName = avatar === 'Arthur' || avatar === 'Amy' ? avatar : 'Amy';
        setUser({
          botName,
          speechSpeed: response.voiceSpeed,
          name: response.name,
          nickName: response.nickName,
          country: response.country,
          city: response.city,
          gender: response.gender,
          hobbies: response.hobbies
        });
      } catch (error) {
        console.error("Error Fetching User:", error);
        setUser({
          botName: 'Amy',
          speechSpeed: '',
          name: '',
          nickName: '',
          country: '',
          city: '',
          gender: '',
          hobbies: []
        });
      }
    };
    fetchUser();
  }, []);
  
  const openConversationfirstMessage = `Hi ${getUserName()}, we are back again, what would you like to talk about today?`;

  const playAudio = async (audioURL) => {
    if (saveConversationTriggered.current) return;
    if (audioURL) {
      audioElementRef.current.src = audioURL;
      audioElementRef.current.volume = 1;
      audioElementRef.current.currentTime = audioPosition;
      audioElementRef.current.removeEventListener("ended", handleAudioEndedRef.current);
      await new Promise((resolve, reject) => {
        audioElementRef.current.addEventListener("canplaythrough", resolve);
        audioElementRef.current.load();
      });

      const handleAudioEnded = () => {
        setIsBotSpeaking(false); 
        setAudioURL(null);
        if (!recordingRef.current && !sessionEndedRef.current) {
          handleStartRecording();
        } else {
          saveConversation();
        }
        setAnimationToPlay(1);
      };
      handleAudioEndedRef.current = handleAudioEnded;
      audioElementRef.current.addEventListener("ended", handleAudioEndedRef.current);
      setIsBotSpeaking(true);

      if (firstMessage) {
        setTimeout(() => {
          setInitialBotMessagePlayed(true); 
        }, 700);
      } else {
        if (!cheerPlaying.current) {
          setAnimationToPlay(3);
        }
      }
      setIsTalkingStarted(false);
      try {
        if (isPaused) {
          audioElementRef.current.pause();
        } else {
          audioElementRef.current.play();
        }
      } catch (err) {
        console.error("Error playing audio", err);
        notification.error({ message: "Error playing audio", description: err.message });
      }
    }
  };

  const handleHelpPage = () => {
    Navigate('/help-page')
  }

  const handlePauseResume = () => {
    if (audioElementRef.current) {
      if (isPaused) {
        audioElementRef.current.currentTime = audioPosition;
        audioElementRef.current.play();
      } else {
        setAudioPosition(audioElementRef.current.currentTime);
        audioElementRef.current.pause();
      }
      setIsPaused(!isPaused);
    }
  };

  const stopAudio = () => {
    try {
      audioElementRef.current.pause();
      audioElementRef.current.currentTime = 0;
    } catch (err) {
      console.error("Error stopping audio", err);
      notification.error({ message: "Error stopping audio", description: err.message });
    }
  };

  const handleBotMessageCompleted = () => {
    if (pendingBotMessages.length > 0) {
      const nextMessage = pendingBotMessages[0]; 
      setPendingBotMessages((prevPending) => {
        return prevPending.slice(1);
      });
      setMessages((prevMessages) => [...prevMessages, nextMessage]);
    }
  };

  const checkGettingToKnowYouScriptStatus = async () => {
    try {
      const response = await getScriptStatus();
      if (response.conversationCompleted === true) {
        promptTypePayload.current = "open-conversation";
      } else if (response.conversationCompleted === false) {
        const conversationArray = response?.conversation;  
        if (conversationArray && conversationArray.length > 1) { 
          const modifiedArray = conversationArray.slice(1); 
          gettingToKnowResumeConversation.current = modifiedArray;
        }
        else {
          gettingToKnowResumeConversation.current = conversationArray;
        }
        setGettingToKnowResume(true);
      }
    } catch (err) {
      console.log("In catch", err);
      setGettingToKnowResume(false);
    }
  };

  const createResumeScriptPrompt = (user) => {
    let conversationArray = gettingToKnowResumeConversation.current;
    const systemPromptExists = conversationArray.some(
                prompt => prompt.role === "system"
        )  
      if (!systemPromptExists) {
        let systemPrompt = gettingToKnowYou(user);
          conversationArray = [systemPrompt["prompts"][0], ...conversationArray];
      }
  
    const newResumePrompt = {
      prompts: conversationArray?.concat(
        gettingToKnowYouResumePrompt(user)
      ),
    };
    return newResumePrompt;
  };

  useEffect(() => {
    checkGettingToKnowYouScriptStatus();
  }, []);

  useEffect(() => {
    generateSessionId(setSessionId);
    setAnimationToPlay(0);
  }, []);

  const checkWhichPromptToLoad = () => {
    if (conversationType === "gettingToKnowYou") {
      if (gettingToKnowResume) {
        promptsRef.current = createResumeScriptPrompt(user);
        utterancePromptsPayload.current = createResumeScriptPrompt(user);
      } else {
        promptsRef.current = gettingToKnowYou(user);
        utterancePromptsPayload.current = gettingToKnowYou(user);
      }
      getBotReply();
    } else if (conversationType === "openConversation") {
      promptsRef.current = socialMedia;
      utterancePromptsPayload.current = socialMedia;
      getBotReply();
    }
  };

  useEffect(() => {
    if (sessionId && !isNull(gettingToKnowResume) && user.botName) {
      if (isNull(gettingToKnowResume)) getBotReply();
      else {
        checkWhichPromptToLoad();
      }
    }
    return () => {
      if (audioElementRef.current) {
        audioElementRef.current.pause();
      }
      audioElementRef.current.removeEventListener(
        "ended",
        handleStartRecording
      );
    };
  }, [sessionId, gettingToKnowResume, user.botName]);

  const setMessagesContent = (currentBotName) => {
    if (
      displayCustomiseFirstMessageInGTKY(
        firstMessage,
        promptTypePayload.current,
        gettingToKnowResume
      )
    )
      return `Hi there! I'm ${currentBotName}, and it's great to meet you. I'm here to help. My job involves listening and supporting you and helping you navigate life's challenges.`;
    else if (firstMessage && promptTypePayload.current === "open-conversation")
      return openConversationfirstMessage;
    else return botMessageContent.current;
  };

  const updateMessage = () => {
    setMessages((prev) => [
      ...prev,
      {
        content: setMessagesContent(user.botName),
        timestamp: new Date(),
        isUser: false,
      },
    ]);
  };

  const removeMiscellaneousText = (text) => {
    if (!text) {
      return "";
    }
    
    let cleanedText = text
      .replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
        ""
      )
      .replace(/^(Kano\s*:?"?\s*)/, "")  
      .trim();
  
    return cleanedText;
  };

  const sanitizeJsonString = (jsonString) => {
    if (!jsonString) {
      return "";
    }
  
    let sanitized = jsonString.replace(/[\u0000-\u001F\u007F-\u009F]/g, "").trim();
  
    return sanitized;
  };

  const jsonFormatter = (item) => {
    try {
      const sanitizedContent = sanitizeJsonString(item.content);

      const parsedContent = JSON.parse(sanitizedContent);

      if (parsedContent && parsedContent.message) {
        return removeMiscellaneousText(parsedContent.message);
      } else {
        return "Error: Message not found in content";
      }
    } catch (error) {
      console.error("JSON parsing error:", error, "Original Content:", item.content);
      return "Error: Invalid JSON content";
    }
  };

  const getBotReply = async () => {
    try {
      if (isNull(gettingToKnowResume)) promptsRef.current = gettingToKnowYou(user);
      const response = await postRequest(
        `${process.env.REACT_APP_API_URL}/openai/conversation`,
        { prompts: promptsRef.current.prompts, type: promptTypePayload.current }
      );

      let botMessage = response[0].message.content;
      if (saveConversationTriggered.current) return;
      try {
        const parsedContent = JSON.parse(botMessage);
        botMessageContent.current = jsonFormatter(response[0].message);

        if (parsedContent.conversation_end) {
          handleStopRecording();
          sessionEndedRef.current = true;
        }
        if (parsedContent?.asked_all_questions) {
          isScriptCompleted.current = true;
        }
      } catch (e) {
        botMessageContent.current = botMessage;
      }

      await synthesizeVoice(
        botMessageContent.current,
        audioURL,
        setAudioURL,
        firstMessage,
        playAudio,
        setResponseReceived,
        cheerPlaying.current,
        promptTypePayload.current,
        gettingToKnowResume,
        user.speechSpeed,
        user.botName || selectedVoice2
      );

      promptsRef.current = {
        ...promptsRef.current,
        prompts: [
          ...promptsRef.current.prompts,
          {
            role: "assistant",
            content: botMessage,
          },
        ],
      };

      utterancePromptsPayload.current = {
        ...utterancePromptsPayload.current,
        prompts: [
          ...utterancePromptsPayload.current.prompts,
          {
            role: "assistant",
            content: botMessage,
            time: new Date().toISOString(),
          },
        ],
      };

      if (!conversationRef.current) {
        conversationRef.current = { prompts: [] };
      }

      conversationRef.current.prompts = [
        ...conversationRef.current.prompts, 
        {
          role: "assistant",
          content: botMessage,
        },
      ];

      if (!cheerPlaying.current) {
        updateMessage();
      }
    } catch (error) {
      console.error("Error getting bot reply: ", error);
      notification.error({ message: "Error getting bot reply", description: error.message });
    }
  };

  useEffect(() => {
    if (isTalkingStarted && audioURL) {
      playAudio(audioURL);
      updateMessage();
    }
  }, [isTalkingStarted, audioURL, user.botName]);

      
  const start = async () => {
    const isIosUser = localStorage.getItem("userPlatform") === "ios";
    try {
      const planResponse = await getPlanDetails();

      // iOS-only: a fully expired subscription (not active, not in grace) blocks the
      // chatbot on web and directs the user to the iOS app. Web/Android are unaffected;
      // the guard is skipped when isSubscriptionActive is undefined (older backend).
      if (isIosUser && planResponse.isSubscriptionActive === false) {
        setIosBlockVisible(true);
        return;
      }

      if (planResponse.planName === "Monthly Plan" || planResponse.planName === "Yearly Plan") {
        setStartTime(
          new Date().toLocaleTimeString("en-US", { timeZone: "America/New_York" })
        );
        setSessionActive(true);
        setTimeout(() => {
          setFirstMessage(false);
        }, 700);
        if (firstMessage) {
          playAudio(audioURL);
        }
        if (rerunEffect < 1) setRerunEffect((prev) => prev + 1);

      } else if (planResponse.planName === "Free Plan") {
        const response = await getConversationLimit(userId);

        if (response.message === "Continue") {
          setStartTime(
            new Date().toLocaleTimeString("en-US", { timeZone: "America/New_York" })
          );
          setSessionActive(true);
          setTimeout(() => {
            setFirstMessage(false);
          }, 700);
          if (firstMessage) {
            playAudio(audioURL);
          }
          if (rerunEffect < 1) setRerunEffect((prev) => prev + 1);

        } else if (response.message === "Time Out") {
          setIsPopupVisible(!isPopupVisible);
          return (
            <LimitTrialCard />
          )
        }
      }
    } catch (error) {
      // iOS-only: no subscription found (e.g. 404) means the user is not entitled → block.
      if (isIosUser) {
        setIosBlockVisible(true);
        return;
      }
      console.error("Error handling start session:", error);
      notification.error({ message: "Error starting session", description: error.message });
    }
    if (rerunEffect < 1) setRerunEffect((prev) => prev + 1);
  };

  const checkConversationForRedFlags = (conversation) => {
    const userMessages = conversation.filter(msg => msg.role === "user");
    for (const message of userMessages) {
      try {
        const parsedContent = JSON.parse(message.content);
        const messageText = parsedContent.message || "";

        const words = messageText.toLowerCase().split(/\s+/);

        if (redFlagWords.some(flagWord =>
          words.includes(flagWord.toLowerCase())
        )) {
          return "red";
        }
      } catch (error) {
        console.error("Error parsing message content:", error);
      }
    }
    return "none";
  };

  const saveConversation = async () => {
    setResponseReceived(false);
    setAnimationToPlay(1);
    saveConversationTriggered.current = true;
    try {
      setSessionActive(false);
      recordingRef.current = false; 
      stopRecording(); 
      const conversationFlag = checkConversationForRedFlags(conversationRef.current.prompts);
      const conversationData = {
        Conversation: conversationRef.current.prompts,
        userId: userId,
        userName: userName,
        startTime: startTime,
        scriptTitle: myFriendScripts[0].title,
        conversationCompleted: false,
        flag: conversationFlag
        //   scriptTitle:
        //     conversationType === "openConversation"
        //       ? myFriendScripts[1].title
        //       : myFriendScripts[0].title,
        //   conversationCompleted: isScriptCompleted.current,
      };

      await postRequest(
        `${process.env.REACT_APP_API_URL}/conversation/utterance`,
        conversationData
      );
  
      if (sessionEndedRef.current) {
        sessionEndedRef.current = true;
        setAnimationToPlay(6);
      } else {
        cleanupStreams();
        Navigate("/ending-page", { state: { botName: user.botName } });
      }
    } catch (error) {
      console.error("Error saving conversation: ", error);
      notification.error({ message: "Error saving conversation", description: error.message });
      Navigate("/ending-page", { state: { botName: user.botName } });
    }
  };

  useEffect(() => {
    if (transcriptions.final) {
      stopAudio();
      const cleanedTranscription = transcriptions.final.replace(
        /\s?[.?]+$/,
        ""
      );
      promptsRef.current = {
        ...promptsRef.current,
        prompts: [
          ...promptsRef.current.prompts,
          {
            role: "user",
            content: `{ \"message\": \"${cleanedTranscription}\"}`,
          },
        ],
      };
      utterancePromptsPayload.current = {
        ...utterancePromptsPayload.current,
        prompts: [
          ...utterancePromptsPayload.current?.prompts,
          {
            role: "user",
            content: `{ \"message\": \"${cleanedTranscription}\"}`,
            time: new Date().toISOString(),
          },
        ],
      };

      if (!conversationRef.current) {
        conversationRef.current = { prompts: [] };
      }

      conversationRef.current.prompts = [
        ...conversationRef.current.prompts, 
        {
          role: "user",
          content: `{ \"message\": \"${cleanedTranscription}\"}`,
          time: new Date().toISOString(),
        },
      ];

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          content: cleanedTranscription,
          timestamp: new Date(),
          isUser: true,
        },
      ]);
      setTranscriptions({ partial: "", final: "" });
      getBotReply();
    }
  }, [transcriptions.final]);

  const handleStartRecording = () => {
    if (sessionEndedRef.current) return;
    setAnimationToPlay(1);
    startRecording(
      "en-US",
      (result) => {
        setTranscriptions((prevTranscriptions) => {
          let newTranscriptions = { ...prevTranscriptions };
          if (result.partial && result.partial !== prevTranscriptions.partial) {
            newTranscriptions.partial = result.partial;
          }
          if (result.final) {
            newTranscriptions.final += result.final;
            newTranscriptions.partial = "";
            recordingRef.current = false;
            cleanupStreams();
            setIsSpeaking(false);
          }
          return newTranscriptions;
        });
      },
      () => {
        setIsSpeaking(true);
      }
    );
  };

  const handleStopRecording = () => {
    stopRecording();
    recordingRef.current = false;
    sessionEndedRef.current = true;
  };

  useEffect(() => {
    if (chatboxRef.current) {
      chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }
  }, [messages]);



  const handleEndSession = () => {
    saveConversation();
    setSessionActive(false);
  };

  const handleInterrupt = () => {
    setIsInterrupting(true);
    if (audioElementRef.current) {
      audioElementRef.current.pause(); 
      audioElementRef.current.currentTime = 0;
    }
    stopRecording(); 
    setIsBotSpeaking(false);
    setIsInterrupting(false);
    setResponseReceived(true);
    handleStartRecording();
  };

  useEffect(() => {
    if (!isBotSpeaking && sessionActive && !isInterrupting && initialBotMessagePlayed) {
      handleStartRecording();
    }
  }, [isBotSpeaking, sessionActive, isInterrupting, initialBotMessagePlayed]);

  return (
    <>
      <div className="chatbox-header">
        {sessionActive && (
          <div
            className="chatbox-content"
            ref={chatboxRef}
            style={{ visibility: showCaptions ? "visible" : "hidden" }}
          >
            {!firstMessage &&
              messages.slice(-1).map(
                (
                  message,
                  index
                ) => (
                  <ChatMessage
                    key={index}
                    content={message.content}
                    timestamp={message.timestamp}
                    isUser={message.isUser}
                    onMessageCompleted={
                      message.isUser ? null : handleBotMessageCompleted
                    }
                    pendingBotMessages={pendingBotMessages}
                    firstMessageforComponent={firstMessageforComponent}
                    setFirstMessageforComponent={setFirstMessageforComponent}
                  />
                )
              )}
          </div>
        )}
        <div className="chatbox-input">
          {showCaptions && (
            <div className="text-area">{transcriptions.partial}</div>
          )}
        </div>
        <div style={{ display: "flex" }}>
          <Tooltip title={showCaptions ? "Hide Captions" : "Show Captions"}>
            {sessionActive && (
              <Button
                className={`captionButton ${showCaptions ? "active" : ""}`}
                onClick={() => setShowCaptions(!showCaptions)}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: showCaptions ? "#2F5BA8" : "white",
                  color: showCaptions ? "white" : "#2F5BA8",
                  border: showCaptions ? "none" : "1px solid #2F5BA8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  marginRight: "10px",
                }}
              >
                CC
              </Button>
            )}
          </Tooltip>
          <Button
            onClick={sessionActive ? handleEndSession : start}
            disabled={!responseReceived}
            style={{
              borderRadius: "60px",
              background: !responseReceived
                ? "#ddd"
                : sessionActive
                  ? "#F53333"
                  : "#4A81BA",
              color: !responseReceived ? "#aaa" : "white",
              margin: "0 auto",
              display: "block",
            }}
          >
            {sessionActive ? "End Session" : "Start Session"}
          </Button>
          {isBotSpeaking ? (
            <Tooltip title="Interrupt Bot">
              <Button
                onClick={handleInterrupt}
                disabled={isInterrupting}
                style={{
                  borderRadius: "60px",
                  background: isInterrupting ? "#ddd" : "#F53333",
                  color: isInterrupting ? "#aaa" : "white",
                  marginLeft: "10px",
                }}
              >
                Interrupt
              </Button>
            </Tooltip>
          ) : (
            (isSpeaking) && (
              <Button
                disabled
                style={{
                  paddingTop: "10px",
                  backgroundColor: "green",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: "60px",
                  cursor: "not-allowed",
                  padding: "10px 20px",
                  marginLeft: "10px",
                }}
              >
                Speak Now
              </Button>
            )
          )}
          {sessionActive && (
            <>
              <button
                onClick={handlePauseResume}
                size="small"
                style={{
                  padding: 0,
                  backgroundColor: "transparent",
                  border: "none",
                  boxShadow: "none",
                  cursor: "pointer", 
                }}
              >
                <img
                  src={isPaused ? pauseButton : pauseStartStop}
                  alt={isPaused ? "Resume" : "Pause"}
                  style={{
                    height: "40px",
                    width: "40px",
                    marginLeft: "10px",
                  }}
                />
              </button>
              {/* <button
                size="small"
                style={{
                  padding: 0,
                  backgroundColor: "none",
                  marginLeft: "10px",
                  border: "none",
                  boxShadow: "none",
                  hover: {
                    backgroundColor: "none",
                    border: "none",
                    boxShadow: "none",
                  },
                }}
              >
                <img
                  src={microphone}
                  alt="microphone"
                  style={{ height: "45px", width: "50px" }}
                />
              </button> */}
            </>
          )}
          <Button
            onClick={handleHelpPage}
            size="small"
            style={{
              padding: 0,
              backgroundColor: "none",
              border: "none",
              boxShadow: "none",
              hover: {
                backgroundColor: "none",
                border: "none",
                boxShadow: "none",
              },
            }}
          >
            <img
              src={help}
              alt="help icon"
              style={{ height: "40px", width: "40px", marginLeft: "10px" }}
            />
          </Button>
          {isPopupVisible && (
            <div className="popup-container">
              <LimitTrialCard onClose={togglePopup} />
            </div>
          )}
          <SubscriptionRestrictionModal
            visible={iosBlockVisible}
            onCancel={() => setIosBlockVisible(false)}
          />
        </div>
      </div>
    </>
  );
};
export default Chatbox;
